import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { RouterProvider } from 'react-router-dom';
import { router } from './router';
import { AuthInit } from './components/auth/AuthInit';
import { Toaster } from './components/ui/sonner';
import { initMobile } from './lib/mobile';
import { initPostHog } from './lib/analytics';
import { initSentry } from './lib/sentry';
import './styles/globals.css';

// Init observability before React renders so first errors are captured. [build trigger: 2026-05-05]
initSentry();
initPostHog();
initMobile();

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      refetchOnWindowFocus: false,
    },
  },
});

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <AuthInit>
        <RouterProvider router={router} />
      </AuthInit>
      <ReactQueryDevtools initialIsOpen={false} />
      <Toaster />
    </QueryClientProvider>
  </StrictMode>,
);
